<template>
  <div>
    <div class="container-header">
      <h3>{{ member.name }}</h3>
      <div class="right-header">
        <div class="navigate-arrows">
          <button
              class="previous-day"
              @click="goToPreviousDay()"
          >
            <i class="atto atto-lt-arrow-b" />
          </button>
          <button
              class="next-day"
              @click="goToNextDay()"
          >
            <i class="atto atto-r-arrow-b" />
          </button>
        </div>
        <datepicker-component
            @onDateSelected="onDateSelected"
        />
      </div>
    </div>
    <div v-if="!loading && entries.length > 0">
      <div class="centered-column">

        <timesheet-overview-component v-if="overview" :overview="overview"/>

        <div class="d-flex">
          <div class="col col-md-6 pl-0 pr-2">
            <timesheet-payroll-component :payroll="payroll" />
          </div>
          <div class="col col-md-6 pr-0 pl-2" v-if="jobCodes">
            <timesheet-job-codes-component :job-codes="jobCodes" />
          </div>
          <div class="col col-md-6 pr-0 pl-2" v-if="entries.length === 1 && entries[0].time_off_entry">
            <time-off-entry-component
                :entry="entries[0].time_off_entry"
                :member="member"
                :can-manage-entry="entries[0].time_off_entry.can_manage_entry"
            />
          </div>
        </div>
      </div>
      <div v-if="!(entries.length === 1 && entries[0].time_off_entry)" class="centered-column" v-for="item in entries">
        <time-off-entry-component
            v-if="item.time_off_entry"
            :entry="item.time_off_entry"
            :member="member"
        />
        <time-entry-component
            v-if="item.time_entry"
            :entry="item.time_entry"
            :member="member"
            :show-map="true"
        />
    </div>
    </div>
    <div v-if="!loading && entries.length === 0">
      <daily-entries-not-found-component />
    </div>
  </div>
</template>

<script>

import DatepickerComponent from "./DatepickerComponent";
import ManualEntryComponent from '../shared/ManualEntryComponent';
import TimeEntryComponent from '../shared/components/TimeEntryComponent';
import TimeOffEntryComponent from '../shared/components/TimeOffEntryComponent';
import TimesheetOverviewComponent from "../shared/components/TimesheetOverviewComponent";
import TimesheetPayrollComponent from "../shared/components/TimesheetPayrollComponent";
import TimesheetJobCodesComponent from "../shared/components/TimesheetJobCodesComponent";
import TimesheetService from "../shared/TimesheetService";
import UtilsService from "../../../shared/services/UtilsService";
import DailyEntriesNotFoundComponent from "../shared/components/DailyEntriesNotFoundComponent";

export default {
  name: "TimeEntryDailyComponent",
  components: {
    DatepickerComponent,
    ManualEntryComponent,
    TimeEntryComponent,
    TimeOffEntryComponent,
    TimesheetOverviewComponent,
    TimesheetPayrollComponent,
    TimesheetJobCodesComponent,
    DailyEntriesNotFoundComponent
  },
  beforeRouteUpdate(to, from, next) {
    if (!UtilsService.isValidDate(to.params.date)) {
      to.params.date = Vue.moment().format('YYYY-MM-DD');
      Vue.router.push({
        name: 'TimeEntryDaily',
        params: {uid: to.params.uid, date: Vue.moment().format('YYYY-MM-DD')}
      });
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!UtilsService.isValidDate(to.params.date)) {
      to.params.date = Vue.moment().format('YYYY-MM-DD');
      Vue.router.push({
        name: 'TimeEntryDaily',
        params: {uid: to.params.uid, date: Vue.moment().format('YYYY-MM-DD')}
      });
    } else {
      next();
    }
  },
  data() {
    return {
      loading: true,
      member: this.getMember(),
      canManageEntry: false,
      date: null,
      jobCodes: null,
      overview: null,
      payroll: null,
      entries: [],
      entryNotFound: false,
      prevFrom: this.$store.state.period.from,
      prevTo: this.$store.state.period.to,
      destroyFromDelete: false
    };
  },
  created() {
    this.getDailyTimeEntries();
  },
  mounted() {
    this.$root.$on('reloadData', this.getDailyTimeEntries);
    this.$root.$on('onEntryDeleted', this.onEntryDeleted);
  },
  beforeDestroy() {
    this.$root.$off('reloadData');
    this.$root.$off('onEntryDeleted');
    if(!this.destroyFromDelete) {
      this.$store.commit("period", {
        from: this.prevFrom,
        to: this.prevTo,
        fromFormatted: this.$moment(this.prevFrom).format('MMM D, YYYY'),
        toFormatted: this.$moment(this.prevTo).format('MMM D, YYYY')
      });
    }
  },
  methods: {
    getMember() {
      let _this = this;
      if(this.$store.state.showArchivedMembers){
        const members = this.$store.state.archivedMembers.filter(item => {
          return item.uid === _this.$route.params.uid;
        });
        if (members.length > 0) {
          return members[0];
        }
      }

      const members = this.$store.state.members.filter(item => {
        return item.uid === _this.$route.params.uid;
      });
      if (members.length > 0) {
        return members[0];
      }
      return this.$store.state.members[0];
    },
    getDailyTimeEntries() {
        this.loading = true;
        this.$store.commit('showLoading');
        TimesheetService.getMemberDailyTimesheets(this.member.uid, this.$route.params.date, this.member.deleted).then((result) => {
          this.canAddEntry = result.can_add_entry;
          this.date = result.period.date;
          this.jobCodes = result.job_codes;
          this.overview = result.overview;
          this.payroll = result.payroll;
          this.entries = result.entries;
          this.loading = false;

          const periodDate = this.$moment(this.date);

          this.$store.commit("period", {
            from: periodDate.format('YYYY-MM-DD'),
            to: periodDate.format('YYYY-MM-DD'),
            fromFormatted: periodDate.format('MMM D, YYYY'),
            toFormatted: periodDate.format('MMM D, YYYY')
          });

          this.$store.commit('hideLoading');
        }).catch((error) => {
          if(error.response.status === 404) {
            this.entryNotFound = true;
          }
          this.loading = false;
          this.$store.commit('hideLoading');
        })
    },
    onDateSelected: function (dateRange) {
      this.$store.commit('overlay', false);
      this.$store.commit("period", {
        from: this.$moment(dateRange.startDate).format('YYYY-MM-DD'),
        to: this.$moment(dateRange.endDate).format('YYYY-MM-DD'),
        fromFormatted: this.$moment(dateRange.startDate).format('MMM D, YYYY'),
        toFormatted: this.$moment(dateRange.endDate).format('MMM D, YYYY')
      });
      this.$router.push({name: 'MemberTimesheets', params: {uid: this.member.uid}});
    },
    goToPreviousDay() {
      let previousDay = this.$moment(this.date).add(-1, 'day').format("YYYY-MM-DD");
      this.$router.push({name: 'TimeEntryDaily', params: {uid: this.member.uid, date: previousDay}})
    },
    goToNextDay() {
      let nextDay = this.$moment(this.date).add(1, 'day').format("YYYY-MM-DD");
      this.$router.push({name: 'TimeEntryDaily', params: {uid: this.member.uid, date: nextDay}})
    },
    onEntryDeleted() {
      if(this.entries.length === 1) {
        this.$store.commit("period", {
          from: this.prevFrom,
          to: this.prevTo,
          fromFormatted: this.$moment(this.prevFrom).format('MMM D, YYYY'),
          toFormatted: this.$moment(this.prevTo).format('MMM D, YYYY')
        });
        this.destroyFromDelete = true;
        this.$router.push({name: 'MemberTimesheets', params: {uid: this.member.uid}});
      } else {
        this.getDailyTimeEntries();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
   .container-body {
      padding-left: 5px;
      padding-right: 5px;
    }

   .container-header {
     margin: 0 32px 0 21px;
     .right-header {
       display: flex;
       flex-flow: row;
       align-items: center;
       justify-content: space-between;

       .navigate-arrows {
         padding-right: 15px;
         padding-bottom: 5px;
         button {
           padding: 0;
           i {
             font-size: 12px;
             font-weight: bold;
             color: #999999;
             width: 30px;
             height: 30px;
             display: inline-flex;
             text-align: center;
             align-items: center;
             justify-content: center;
           }
           &:hover {
             i {
               background-color: #EFEFEF;
               color: #2f0404;
               border-radius: 100%;
             }
           }
         }
       }
     }
   }

  .white-card {
    height: auto;
  }
</style>